// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1yhYM","image":"App_image__rw05Z"};